import accountSettingsModule from '../accountSettingsModule';

function modalConstantsService(languageResource, errorMessageService) {
  'ngInject';

  const ls = languageResource;
  const socialDisconnectErrorMapper = errorMessageService.createErrorMapper(
    {
      // error messages based on SocialAuthenticationErrors Enum from Roblox.Authentication.Api
      4: ls.get('Response.InvalidPassword')
    },
    ls.get('Message.Error.Default')
  );

  return {
    default: {
      positiveBtnText: ls.get('Action.Dialog.Yes'),
      negativeBtnText: ls.get('Action.Dialog.No'),
      submitButtonText: ls.get('Action.Dialog.Success'),
      success: {
        title: ls.get('Heading.Dialog.DefaultSuccess'),
        body: ls.get('Response.Dialog.DefaultSuccessMessage')
      },
      error: {
        title: ls.get('Heading.Dialog.DefaultError'),
        body: ls.get('Response.Dialog.DefaultErrorMessage')
      },
      errorMessage: ls.get('Response.Dialog.DefaultErrorTitle')
    },
    secureSignOut: {
      success: {
        body: ls.get('Response.Dialog.SignoutSessionsConfirmation')
      },
      error: {
        body: ls.get('Response.Dialog.SignoutSessionFailed')
      }
    },
    disconnectXbox: {
      error: {
        body: ls.get('Response.Dialog.DisconnectXBoxError')
      }
    },
    updateNotificationSettings: {
      error: {
        body: ls.get('Response.Dialog.UpdateNotificationSettingsError')
      }
    },
    twoStepVerification: {
      success: {
        title: ls.get('Response.Dialog.TwoStepSuccessTitle'),
        titleIcon: 'icon-like',
        body: ls.get('Response.Dialog.TwoStepSucessBody')
      },
      disabling: {
        title: ls.get('Response.Dialog.Warning'),
        body: ls.get('Response.Dialog.TwoStepDisableWarning')
      },
      missingEmail: ls.get('Description.Dialog.MissingEmailTwoStepVerification'),
      unverifiedEmail: ls.get('Description.Dialog.UnverifiedEmailTwoStepVerification')
    },
    birthdayChange: {
      default: {
        title: ls.get('Response.Dialog.Warning'),
        body: ls.get('Response.Dialog.BirthdayChangeDefaultWarning')
      },
      withSocialSignOn: {
        body: ls.get('Response.Dialog.BirthdayChangeSocialWarning'),
        positiveBtnText: ls.get('Action.SuccessDialogButtonText'),
        negativeBtnText: ls.get('Action.Dialog.Cancel')
      },
      needPassword: {
        title: ls.get('Response.Dialog.BirthdayChangePasswordTitle'),
        body: ls.get('Response.Dialog.BirthdayChangePasswordBody')
      }
    },
    emailSet: {
      emailRequiredMessage: ls.get('Label.Dialog.EmailRequired'),
      emailSetSuccessMessage: ls.get('Label.Dialog.EmailAddressChanged'),
      invalidEmailAddressMessage: ls.get('Response.Dialog.InvalidEmailAddress'),
      addEmailU13Label: ls.get('Label.Dialog.AddEmailUnder13'),
      addEmailO13Label: ls.get('Label.Dialog.AddEmailOver13'),
      addEmailLabel: ls.get('Action.Dialog.AddEmail'),
      changeEmailU13Label: ls.get('Label.Dialog.ChangeEmailUnder13'),
      changeEmailO13Label: ls.get('Label.Dialog.ChangeEmailOver13'),
      changeEmailLabel: ls.get('Action.Dialog.ChangeEmail')
    },
    phoneSet: {
      addActionLabel: ls.get('Action.Dialog.AddPhone'),
      editActionLabel: ls.get('Action.Dialog.EditPhonePrimary'),
      updateSuccessMessage: ls.get('Response.NotificationBar.PhoneVerifyConfirmation'),
      deleteSuccessMessage: ls.get('Response.NotificationBar.PhoneRemovedConfirmation'),
      countryListErrorMessage: ls.get('Response.Dialog.CountryListError')
    },
    passwordSet: {
      changePasswordMessage: ls.get('Heading.Dialog.ChangePassword'),
      addPasswordMessage: ls.get('Heading.Dialog.AddPassword'),
      matchErrorMessage: ls.get('Response.Dialog.ChangePasswordNoMatch'),
      changePasswordSuccess: ls.get('Heading.Dialog.ChangePasswordSuccess')
    },
    passwordChange: {
      tooManyRequests: ls.get('MessageTooManyAttemptsError'),
      invalidPassword: ls.get('Response.Dialog.PasswordRulesError'),
      invalidCurrentPassword: ls.get('Response.Dialog.ChangePasswordIncorrectPassword'),
      pinLocked: ls.get('MessagePinLockedError')
    },
    pinCreate: {
      matchErrorMessage: ls.get('Response.Dialog.PinCreateMismatch'),
      missingEmail: ls.get('Description.Dialog.MissingEmailAccountPin'),
      unverifiedEmail: ls.get('Description.Dialog.UnverifiedEmailAccountPin')
    },
    changeUsername: {
      missingEmail: ls.get('Description.Dialog.MissingEmailUsername'),
      unverifiedEmail: ls.get('Description.Dialog.UnverifiedEmailUsername'),
      changeUsernameBuy: ls.get('Action.Dialog.ChangeUsernameBuy'),
      changeUsernameMessage(robuxString) {
        return ls.get('Description.Dialog.InsufficientFundsWarning', robuxString);
      },
      changeUsernameTitle: ls.get('Heading.Dialog.InsufficientFunds'),
      error: {
        notProvided: ls.get('Response.Dialog.ChangeUsernameNoInput'),
        notAvailable: ls.get('Response.Dialog.ChangeUsernameNotAvailable'),
        notAllowed: ls.get('Response.Dialog.ChangeUsernameNotAllowed')
      }
    },
    socialDisconnect: {
      unlinkTitle(provider) {
        return ls.get('Heading.Unlink', { provider });
      },
      getMessageFromError: socialDisconnectErrorMapper.getErrorMessageFromResponse
    }
  };
}

accountSettingsModule.factory('modalConstantsService', modalConstantsService);

export default modalConstantsService;
